import Box from '@mui/material/Box';
import { UseIcon } from 'assets/Icon.js';
import { Helpdesk } from 'components/helpdesk/index.js';
import { useMyUser } from 'shared/context/useMyUser.js';
import { useNavigateToDefaultPage } from 'shared/context/useNavigateToDefaultPage.js';

import { NotificationBell } from '../NotificationBell/index.js';
import { TopBarAvatar } from '../TopBarAvatar/index.js';
import {
  AppBar,
  LogoWrapper,
  Menu,
  MenuButton,
  ToolBar,
} from './TopBar.styles.js';

interface TopBarProps {
  toggleNav: () => void;
}

export const TopBar = ({ toggleNav }: TopBarProps) => {
  const { isLoggedIn, user } = useMyUser();
  const { navigateToDefaultPage } = useNavigateToDefaultPage({ user });

  return (
    <AppBar position="fixed" data-testid="topbar">
      <ToolBar variant="dense">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Box display="flex" alignItems="center">
            <MenuButton disableRipple onClick={toggleNav}>
              <Menu />
            </MenuButton>
            <LogoWrapper onClick={navigateToDefaultPage}>
              <UseIcon
                icon="safIconDarkSvg"
                sx={{ height: { xs: 30, md: 45 }, width: 80 }}
                svgProps={{ viewBox: '0 0 548 256' }}
              />
            </LogoWrapper>
          </Box>
          <Box display="flex" alignItems="center" gap={3}>
            {isLoggedIn && <NotificationBell />}
            <Helpdesk />
            {isLoggedIn && user
              ? (
                  <TopBarAvatar username={user.name} email={user.email} />
                )
              : null}
          </Box>
        </Box>
      </ToolBar>
    </AppBar>
  );
};
